__turbopack_context__.v({
  "cellTitle": "TeppYq_cellTitle",
  "container": "TeppYq_container",
  "editGridCell": "TeppYq_editGridCell",
  "gridContainer": "TeppYq_gridContainer",
  "header": "TeppYq_header",
  "infoGridCell": "TeppYq_infoGridCell",
  "infoSection": "TeppYq_infoSection",
});
